import { Fragment } from "react";
import AppAppBar from "../pages/landingPage/components/AppAppBar";
import Footer from "../pages/landingPage/components/Footer";

const WebsiteLayout = ({children}) =>  {

    return (
        <Fragment>
            <AppAppBar />
                {children}
            <Footer/>
        </Fragment>
    );
}

export default WebsiteLayout;